/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OIDCChallengeOptions } from './OIDCChallengeOptions';
import {
    OIDCChallengeOptionsFromJSON,
    OIDCChallengeOptionsFromJSONTyped,
    OIDCChallengeOptionsToJSON,
} from './OIDCChallengeOptions';

/**
 * 
 * @export
 * @interface OIDCChallengeAllOf
 */
export interface OIDCChallengeAllOf {
    /**
     * 
     * @type {OIDCChallengeOptions}
     * @memberof OIDCChallengeAllOf
     */
    options: OIDCChallengeOptions;
}

/**
 * Check if a given object implements the OIDCChallengeAllOf interface.
 */
export function instanceOfOIDCChallengeAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function OIDCChallengeAllOfFromJSON(json: any): OIDCChallengeAllOf {
    return OIDCChallengeAllOfFromJSONTyped(json, false);
}

export function OIDCChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': OIDCChallengeOptionsFromJSON(json['options']),
    };
}

export function OIDCChallengeAllOfToJSON(value?: OIDCChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': OIDCChallengeOptionsToJSON(value.options),
    };
}

